import { makeStyles } from "@material-ui/core";

export const useFloatingActionsStyles = makeStyles((theme) => ({
  floatingActionsLeft: {
    position: "absolute",
    right: "-55px", // 15px para fora do balão
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 20,
    pointerEvents: "auto", // Garantir que só responda a eventos quando necessário
    width: 0, // Não ocupar espaço no layout
    height: 0, // Não ocupar espaço no layout
  },

  floatingActionsRight: {
    position: "absolute",
    left: "-55px", // 15px para fora do balão
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 20,
    pointerEvents: "auto", // Garantir que só responda a eventos quando necessário
    width: 0, // Não ocupar espaço no layout
    height: 0, // Não ocupar espaço no layout
  },
}));
